import App from "./App.svelte";
import props from "./props/index.js";
import track from "./utils/track.js"

let app;
const localStorageKey = "mag-interactive--future-of-science-nav-6";

let init = () => {
  /* ---------------------------- Svelte component ---------------------------- */
  app = new App({
    target: document.querySelector("#server-rendered-html"),
    hydrate: true,
    props: { ...props },
  });

  
  app.$on("update", () => {
	console.log("Update");
    let requestData = window.localStorage.getItem(localStorageKey);
    let documentHeight = document.querySelector("body").offsetHeight;
    if (requestData) {
      window.parent.postMessage(
        { height: documentHeight + 20, requestData: JSON.parse(requestData) },
        "*"
      );
    }
    console.log("messageOnUpdate", {
      height: documentHeight,
      requestData: requestData,
    });
  });

	/* -------------------------------- Tracking -------------------------------- */
	// Set up the link tracking
	const { send } = track();
	const sendData = function () {
		send(this.dataset);
	}
	
	document.querySelectorAll("[data-event-action]")
		.forEach(elem => {
			elem.addEventListener("click", sendData);
		});
  
};

document.addEventListener("DOMContentLoaded", init);

export default app;
